import React, { useState, useEffect } from "react";
import { Box, Typography, Grid, TextField, Paper, Checkbox, FormControlLabel, Avatar, Button, IconButton, CircularProgress } from "@mui/material";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

import { CloudUpload as CloudUploadIcon, Delete as DeleteIcon } from "@mui/icons-material";
import { storage } from "../../../firebase"; // Ensure your firebase config is exported

function MotherInfo({ form, handleChange }) {

  const [sameAddress, setSameAddress] = useState(false);
  const [sameAsFather, setSameAsFather] = useState(false);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    if (sameAsFather) {
      handleChange("mother_currentAddress", form.father_currentAddress || "");
      handleChange("mother_currentPin", form.father_currentPin || "");

      handleChange("mother_permanentAddress", form.father_permanentAddress || "");
      handleChange("mother_permanentPin", form.father_permanentPin || "");

      handleChange("mother_officeAddress", form.father_officeAddress || "");
      handleChange("mother_officePin", form.father_officePin || "");
    }
  }, [
    sameAsFather,
    form.father_currentAddress,
    form.father_currentPin,
    form.father_permanentAddress,
    form.father_permanentPin,
    form.father_officeAddress,
    form.father_officePin
  ]);

  useEffect(() => {
    if (sameAddress) {
      handleChange("mother_permanentAddress", form.mother_currentAddress || "");
      handleChange("mother_permanentPin", form.mother_currentPin || "");
    }
  }, [sameAddress, form.mother_currentAddress, form.mother_currentPin]);

  const handlePhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      // Create a unique path for the photo
      const storageRef = ref(storage, `mother_photos/${Date.now()}_${file.name}`);

      // Upload file
      await uploadBytes(storageRef, file);

      // Get Download URL
      const downloadURL = await getDownloadURL(storageRef);

      // Update form state with the URL
      handleChange("mother_photo", downloadURL);
    } catch (error) {
      console.error("Upload error:", error);
      alert("Failed to upload image");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center" bgcolor="#f4f6f8">

      <Paper sx={{ p: 1 }}>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={sameAsFather}
                onChange={(e) => setSameAsFather(e.target.checked)}
              />
            }
            label="Same as Father Address"
          />
        </Grid>
        {/* HEADER */}
        <Box sx={{ background: "teal", color: "#fff", p: 1, mb: 3 }}>
          <Typography fontWeight="bold">
            4) Mother's Information (Please fill in BLOCK CAPITAL LETTERS ONLY)
          </Typography>
        </Box>

        <Grid className="row">
          <Grid className="col-sm-9">
            <Grid className="row" spacing={2}>

              <Grid className="col-sm-3 mb-3" item xs={12}>
                <TextField
                  fullWidth
                  label="Name (Start's with Surname)"
                  size="small"
                  value={form.mother_name || ""}
                  onChange={(e) => handleChange("mother_name", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={9}>
                <TextField
                  fullWidth
                  label="Current Residential Address"
                  size="small"
                  value={form.mother_currentAddress || ""}
                  onChange={(e) => handleChange("mother_currentAddress", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={3}>
                <TextField
                  fullWidth
                  label="Pin Code"
                  size="small"
                  value={form.mother_currentPin || ""}
                  onChange={(e) => handleChange("mother_currentPin", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={9}>
                <TextField
                  fullWidth
                  label="Permanent Residential Address"
                  size="small"
                  value={form.mother_permanentAddress || ""}
                  onChange={(e) => handleChange("mother_permanentAddress", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={3}>
                <TextField
                  fullWidth
                  label="Pin Code"
                  size="small"
                  value={form.mother_permanentPin || ""}
                  onChange={(e) => handleChange("mother_permanentPin", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={6}>
                <TextField
                  fullWidth
                  label="PAN No."
                  size="small"
                  value={form.mother_pan || ""}
                  onChange={(e) => handleChange("mother_pan", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={6}>
                <TextField
                  fullWidth
                  label="Adhar No."
                  size="small"
                  value={form.mother_adhar || ""}
                  onChange={(e) => handleChange("mother_adhar", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={6}>
                <TextField
                  fullWidth
                  label="Organization"
                  size="small"
                  value={form.mother_organization || ""}
                  onChange={(e) => handleChange("mother_organization", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={6}>
                <TextField
                  fullWidth
                  label="Qualification"
                  size="small"
                  value={form.mother_qualification || ""}
                  onChange={(e) => handleChange("mother_qualification", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={6}>
                <TextField
                  fullWidth
                  label="Occupation"
                  size="small"
                  value={form.mother_occupation || ""}
                  onChange={(e) => handleChange("mother_occupation", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={6}>
                <TextField
                  fullWidth
                  label="Designation"
                  size="small"
                  value={form.mother_designation || ""}
                  onChange={(e) => handleChange("mother_designation", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={9}>
                <TextField
                  fullWidth
                  label="Office Address"
                  size="small"
                  value={form.mother_officeAddress || ""}
                  onChange={(e) => handleChange("mother_officeAddress", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={3}>
                <TextField
                  fullWidth
                  label="Pin Code"
                  size="small"
                  value={form.mother_officePin || ""}
                  onChange={(e) => handleChange("mother_officePin", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={12}>
                <TextField
                  fullWidth
                  label="Email ID"
                  size="small"
                  value={form.mother_email || ""}
                  onChange={(e) => handleChange("mother_email", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={4}>
                <TextField
                  fullWidth
                  label="Mobile 1"
                  size="small"
                  value={form.mother_mobile1 || ""}
                  onChange={(e) => handleChange("mother_mobile1", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={4}>
                <TextField
                  fullWidth
                  label="Mobile 2"
                  size="small"
                  value={form.mother_mobile2 || ""}
                  onChange={(e) => handleChange("mother_mobile2", e.target.value)}
                />
              </Grid>

              <Grid className="col-sm-3 mb-3" item xs={4}>
                <TextField
                  fullWidth
                  label="Landline"
                  size="small"
                  value={form.mother_landline || ""}
                  onChange={(e) => handleChange("mother_landline", e.target.value)}
                />
              </Grid>

            </Grid>
          </Grid>
          <Grid className="col-sm-3">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              sx={{
                border: "1px dashed #ccc",
                p: 2,
                borderRadius: 2,
                height: "100%",
                minHeight: "250px",
                bgcolor: "#fafafa"
              }}
            >
              <Typography variant="caption" sx={{ mb: 1, fontWeight: "bold" }}>MOTHERS'S PHOTO</Typography>

              <Avatar
                variant="rounded"
                src={form.mother_photo || ""}
                sx={{ width: 150, height: 180, mb: 2, border: "1px solid #ddd" }}
              >
                {uploading ? <CircularProgress size={24} /> : "No Image"}
              </Avatar>

              <Button
                variant="contained"
                component="label"
                size="small"
                startIcon={<CloudUploadIcon />}
                disabled={uploading}
                sx={{ bgcolor: "teal", "&:hover": { bgcolor: "#00695c" } }}
              >
                {uploading ? "Uploading..." : "Upload Photo"}
                <input type="file" hidden accept="image/*" onChange={handlePhotoChange} />
              </Button>

              {form.mother_photo && (
                <IconButton
                  color="error"
                  size="small"
                  sx={{ mt: 1 }}
                  onClick={() => handleChange("mother_photo", "")}
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          </Grid>
        </Grid>

      </Paper>

    </Box>
  );
}

export default MotherInfo;